import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/formCategory/importer/formCategoryImporterActions';

export default importerReducers(actions);
